import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from "@material-ui/core/Grid";
import makeStyles from "@material-ui/styles/makeStyles";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import Typography from "@material-ui/core/Typography";

const useCardStyles = makeStyles(theme => ({
    card: {
        minWidth: 275,
    },
    grid: {
        margin:theme.spacing(2)
    },
    cardActionsContainer: {
        display: 'flex',
        flexDirection: 'column'
    },
}));

const Mobile = ({ data, onDelete, onEdit, onCompletedVaccination }) => {
    const classes = useCardStyles();

    const [anchorEl, setAnchorEl] = React.useState(null);

    
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDelete = () => {
        setAnchorEl(null);
        onDelete();
    };

    const handleEdit = () => {
        setAnchorEl(null);
        onEdit();
    };

    const handleCompletedVaccination = () => {
        setAnchorEl(null);
        onCompletedVaccination();
    };

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    return <Grid item>
        <Card className={classes.card}>
            <CardHeader
                action={
                    <IconButton aria-label="settings" onClick={handleClick}>
                        <MoreVertIcon />
                    </IconButton>
                }
                title={`Shed Name : ${data.shedName}`}
            />
            <CardContent>
                <Grid
                    container
                    justify='space-between'
                    alignItems='flex-end'
                >
                    <Grid item className={classes.grid}>
                        <Typography variant="h5" component="h2">
                            {data.batchName}
                        </Typography>
                        <Typography color="textSecondary">
                            Batch Name
                    </Typography>
                    </Grid>
                    <Grid item className={classes.grid}>
                        <Typography variant="h5" component="h2">
                            {data.vaccineName}
                        </Typography>
                        <Typography color="textSecondary">
                            Vaccine Name
                    </Typography>
                    </Grid><br />
                    <Grid item className={classes.grid}>
                        <Typography variant="h5" component="h2" >
                          {data.dueDays > 0 ? "Due - "+data.dueDays+" days" : 
                          data.dueDays < 0 ? "OverDue - "+Math.abs(data.dueDays)+" days" :
                          "Today"}
                        </Typography>
                        <Typography color="textSecondary">
                            Due(in Days)
                    </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
        {data.vaccinationType !== 1 ?
            <Menu
                id="batch-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={handleCompletedVaccination}>Vaccinated Date</MenuItem>
            </Menu>
            :
            <Menu
                id="batch-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={handleCompletedVaccination}>Vaccinated Date</MenuItem>
                <MenuItem onClick={handleEdit}>Edit</MenuItem>
                <MenuItem onClick={handleDelete}>Delete</MenuItem>
            </Menu>
        }
    </Grid >
};

export default Mobile;